// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__zSTUo","header__title":"Header_header__title__1t4wo"};